.field {
	display: flex;
	flex-direction: column;
	gap: 0.35rem;
	min-width: 0;
}

.col12 {
	grid-column: span 12;
}

.col6 {
	grid-column: span 6;
}

.col3 {
	grid-column: span 3;
}

.label {
	font-weight: 600;
	font-size: 0.875rem;
	color: #374151;
	margin-bottom: 0;
}

.req {
	color: #ef4444;
	margin-left: 2px;
}

.phoneInput {
	display: flex;
	align-items: center;
	width: 100%;
	border: 1px solid #e5e7eb;
	border-radius: 0.5rem;
	background: #fff;
	padding: 0 0.65rem;
	transition:
		border-color 0.15s ease,
		box-shadow 0.15s ease;

	&:focus-within {
		border-color: #818cf8;
		box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
	}

	:global {
		.PhoneInputCountry {
			flex-shrink: 0;
			display: flex;
			align-items: center;
			margin-right: 0.5rem;
			position: relative;
		}

		.PhoneInputCountryIcon {
			width: 32px !important;
			height: 24px !important;
			box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
			border-radius: 4px;
			overflow: hidden;
			display: block !important;
		}

		.PhoneInputCountryIcon--border {
			box-shadow:
				0 1px 3px rgba(0, 0, 0, 0.15),
				inset 0 0 0 1px rgba(0, 0, 0, 0.1);
		}

		.PhoneInputCountryIconImg {
			display: block;
			width: 100%;
			height: 100%;
		}

		.PhoneInputCountrySelect {
			position: absolute;
			top: 0;
			left: 0;
			height: 100%;
			width: 100%;
			z-index: 1;
			border: 0;
			opacity: 0;
			cursor: pointer;

			&:focus + .PhoneInputCountryIcon {
				outline: 2px solid #818cf8;
				outline-offset: 2px;
			}
		}

		.PhoneInputCountrySelectArrow {
			display: none;
		}

		.PhoneInputInput {
			flex: 1;
			border: none;
			outline: none;
			padding: 0.5rem 0;
			font-size: 0.95rem;
			color: #111827;
			background: transparent;
			width: 100%;

			&::placeholder {
				color: #9ca3af;
			}
		}
	}
}

.phoneInput.sm {
	padding: 0 0.5rem;

	:global {
		.PhoneInputCountryIcon {
			width: 26px !important;
			height: 19px !important;
		}

		.PhoneInputInput {
			padding: 0.35rem 0;
			font-size: 0.875rem;
		}
	}
}

.phoneInput.lg {
	padding: 0 0.85rem;

	:global {
		.PhoneInputCountryIcon {
			width: 36px !important;
			height: 27px !important;
		}

		.PhoneInputInput {
			padding: 0.65rem 0;
			font-size: 1rem;
		}
	}
}

.phoneInputError {
	:global {
		.PhoneInputInput {
			border-color: #ef4444;

			&:focus {
				box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.15);
			}
		}
	}
}

.error {
	font-size: 0.8rem;
	color: #ef4444;
	margin-top: 0.25rem;
}

.helper {
	font-size: 0.8rem;
	color: #6b7280;
	margin-top: 0.25rem;
}
